import React from 'react'

import Icon from '../struct/icon/Icon';

import styles from './Status.less'

class Status extends React.Component {
    render() {
        const {className, status, successText, errorText, ...props} = this.props
        const {status: statusClass} = styles
        const classes = [statusClass]

        if (className) {
            classes.push(className)
        }

        return (
            <div className={classes.join(' ')} {...props}>
                {status === Status.LOADING && (
                    <div><Icon name="loading"/>Загрузка</div>
                )}
                {status === Status.SUCCESS && (
                    <div><Icon name="yes"/>{successText || 'Сохранено'}</div>
                )}
                {status === Status.ERROR && (
                    <div><Icon name="no"/>{errorText || 'Ошибка'}</div>
                )}
            </div>
        )
    }
}

Status.LOADING = 'loading'
Status.SUCCESS = 'success'
Status.ERROR = 'error'
Status.NONE = ''

export default Status

